<template>
  <form>
    <v-subheader>{{labels.appID}}</v-subheader>
    <v-container fluid grid-list-lg>
      <v-layout row wrap>
        <v-flex lg2 md3 xs6 v-if="checkAccess(['motorQuote'])">
          <v-card :class="quoteForm.appID === constAppID.MOTOR ? 'quoteCard cardActive' : 'quoteCard'" @click.native="quoteForm.appID = constAppID.MOTOR">
            <v-layout fill-height column justify-center align-center>
              <v-icon>{{appIcon.MOTOR}}</v-icon>
              <span>Motor</span>
            </v-layout>
          </v-card>
        </v-flex>
        <v-flex lg2 md3 xs6 v-if="checkAccess(['travelQuote'])">
          <v-card :class="quoteForm.appID === constAppID.TRAVEL ? 'quoteCard cardActive' : 'quoteCard'" @click.native="quoteForm.appID = constAppID.TRAVEL">
            <v-layout fill-height column justify-center align-center>
              <v-icon>{{appIcon.TRAVEL}}</v-icon>
              <span>Travel</span>
            </v-layout>
          </v-card>
        </v-flex>
        <v-flex lg2 md3 xs6 v-if="checkAccess(['fireQuote'])">
          <v-card :class="quoteForm.appID === constAppID.FIRE ? 'quoteCard cardActive' : 'quoteCard'" @click.native="quoteForm.appID = constAppID.FIRE">
            <v-layout fill-height column justify-center align-center>
              <v-icon>{{appIcon.FIRE}}</v-icon>
              <span>Fire</span>
            </v-layout>
          </v-card>
        </v-flex>
        <v-flex lg2 md3 xs6 v-if="checkAccess(['paQuote'])">
        <v-card :class="quoteForm.appID === constAppID.PA ? 'quoteCard cardActive' : 'quoteCard'" @click.native="quoteForm.appID = constAppID.PA">
          <v-layout fill-height column justify-center align-center>
            <v-icon>{{appIcon.PA}}</v-icon>
            <span>Personal Accident</span>
          </v-layout>
        </v-card>
      </v-flex>
        <v-flex lg2 md3 xs6 v-if="checkAccess(['cargoQuote'])">
          <v-card :class="quoteForm.appID === constAppID.CARGO ? 'quoteCard cardActive' : 'quoteCard'" @click.native="quoteForm.appID = constAppID.CARGO">
            <v-layout fill-height column justify-center align-center>
              <v-icon>{{appIcon.CARGO}}</v-icon>
              <span>Cargo</span>
            </v-layout>
          </v-card>
        </v-flex>
        <v-flex lg2 md3 xs6 v-if="checkAccess(['maidQuote'])">
          <v-card :class="quoteForm.appID === constAppID.MAID ? 'quoteCard cardActive' : 'quoteCard'" @click.native="quoteForm.appID = constAppID.MAID">
            <v-layout fill-height column justify-center align-center>
              <v-icon>{{appIcon.MAID}}</v-icon>
              <span>Maid</span>
            </v-layout>
          </v-card>
        </v-flex>
        <v-flex lg2 md3 xs6 v-if="checkAccess(['packageQuote'])">
          <v-card :class="quoteForm.appID === constAppID.PACKAGE ? 'quoteCard cardActive' : 'quoteCard'" @click.native="quoteForm.appID = constAppID.PACKAGE">
            <v-layout fill-height column justify-center align-center>
              <v-icon>{{appIcon.PACKAGE}}</v-icon>
              <span>Package</span>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <v-layout row wrap class="mt-3">
      <v-flex xs12>
        <v-card>
          <v-card-text>
            <v-layout row wrap>
              <v-flex lg8 md12>
                <v-container fluid grid-list-lg>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-subheader>{{labels.quoteInfo}}</v-subheader>
                    </v-flex>
                    <v-flex xs12>
                      <message :messages="messages"></message>
                    </v-flex>
                    <v-flex lg6 xs12>
                      <v-autocomplete :items="intermediaryList" v-model="quoteForm.intermediary" :label="labels.intermediary" item-text="label" item-value="value" data-vv-name="intermediary" :data-vv-as="labels.intermediary" :error-messages="errors.collect('intermediary')" v-validate="'required'"></v-autocomplete>
                    </v-flex>
                    <v-flex lg6 xs12>
                    </v-flex>
                    <v-flex xs12>
                      <v-subheader>{{labels.prospectInfo}}</v-subheader>
                    </v-flex>
                    <v-flex lg6 xs12>
                      <v-text-field :label="labels.salesOppName" v-model="quoteForm.salesOppName" :error-messages="errors.collect('salesOppName')" v-validate="'max:128|name'" data-vv-name="salesOppName" :data-vv-as="labels.salesOppName" prepend-icon="mdi-comment-account"></v-text-field>
                    </v-flex>
                    <v-flex lg6 xs12>
                    </v-flex>
                    <v-flex lg6 xs12>
                      <v-text-field v-int-mask="{intScale: 8}" type="tel" :label="labels.salesOppPhone" v-model="quoteForm.salesOppPhone" :error-messages="errors.collect('salesOppPhone')" v-validate="'numeric|max:8'" data-vv-name="salesOppPhone" :data-vv-as="labels.salesOppPhone" prepend-icon="mdi-phone"></v-text-field>
                    </v-flex>
                    <v-flex lg6 xs12>
                      <v-text-field :label="labels.salesOppEmail" v-model="quoteForm.salesOppEmail" type="email" :error-messages="errors.collect('salesOppEmail')" v-validate="'email'" data-vv-name="salesOppEmail" :data-vv-as="labels.salesOppEmail" prepend-icon="mdi-email"></v-text-field>
                    </v-flex>
                    <v-flex lg12>
                      <v-textarea :label="labels.salesOppComments" v-model="quoteForm.salesOppComments" :error-messages="errors.collect('salesOppComments')" v-validate="'max:255|entry'" data-vv-name="salesOppComments" :data-vv-as="labels.salesOppComments" prepend-icon="mdi-comment-text" :counter="255"></v-textarea>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-btn color="primary" type="submit" large :loading="$store.state.agency.quotation.saving" @click.prevent="doProceed">
                      Proceed
                      <v-icon right dark>mdi-playlist-check</v-icon>
                    </v-btn>
                  </v-layout>
                </v-container>
              </v-flex>
              <v-flex lg4 hidden-md-and-down>
                <!-- <v-card color="grey lighten-4" class="ml-4 prospectHelp">
                  <v-card-text>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
                  </v-card-text>
                </v-card> -->
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <!-- <v-layout row wrap>
      <v-spacer></v-spacer>
      <v-btn color="primary" type="submit" large :loading="$store.state.agency.quotation.saving" @click.prevent="doProceed">
        Proceed
        <v-icon right dark>mdi-playlist-check</v-icon>
      </v-btn>
    </v-layout> -->
  </form>
</template>

<script>
import { mapGetters } from 'vuex'
import { AGENCY_QUOTATION_RESET } from '@/store/types'
import MessageMixin from '@/mixins/message'
import { appID, appIcon } from '@/const/underwriting'

export default {
  data() {
    return {
      labels: {
        appID: 'Quotation Type',
        quoteInfo: 'Quotation Information',
        intermediary: 'Intermediary*',
        prospectInfo: 'Prospect Information',
        salesOppName: 'Name',
        salesOppEmail: 'Email',
        salesOppPhone: 'Contact No',
        salesOppComments: 'Other Information'
      },
      quoteForm: {
        appID: undefined,
        intermediary: undefined,
        salesOppName: undefined,
        salesOppEmail: undefined,
        salesOppPhone: undefined,
        salesOppComments: undefined
      }
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    constAppID() {
      return appID
    },
    intermediaryList() {
      return this.$store.state.agency.quotationSettings.intermediaries
    },
    appIcon() {
      return appIcon
    }
  },
  mounted() {
    // Start of quotation to reset quotation state
    this.$store.commit(AGENCY_QUOTATION_RESET)

    // If there is only 1 intermediary in the list, assign it
    if (this.intermediaryList && this.intermediaryList.length === 1) {
      this.quoteForm.intermediary = this.intermediaryList[0].value
    }
  },
  methods: {
    doProceed() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          // Manual validation here
          if (!this.quoteForm.appID) {
            this.$snotify.error('Please select a Quotation Type')
          } else {
            this.doSave()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doSave() {
      this.$store.dispatch('createQuote', this.quoteForm)
    }
  },
  mixins: [
    MessageMixin
  ]
}
</script>

<style lang="scss">
@import "../../assets/scss/agency.scss";

.prospectHelp {
  min-height: 550px;
}
</style>
